const BusinessPlan = () => {
  return (
    <>
      <p>Include information on:</p>
      <ul>
        <li>The business you are proposing</li>
        <li>How you plan on generating revenue</li>
        <li>The size of investment you need</li>
        <li>How the funds will be used</li>
        <li>Details of your experience in the industry</li>
      </ul>
    </>
  );
};

export default BusinessPlan;
